module.exports = __webpack_public_path__ + "img/default-admin.f4f538f2.png";